export const BID_MODE = {
  NONE: 'None',
  UPDATE_DEFAULT: 'UpdateDefault',
  CLEAR_KEYWORD: 'ClearKeyword',
};
